import React, { useState, useEffect, useCallback } from "react";
import InputForm from "../../../../../../components/InputForm";
import { LabelWithBackLine } from "../../../../../../components/LabelWithBackLine";
import { PublicationModal } from "./components/PublicationModal";
import { Table } from "./components/Table";
import useFetchData from "./helpers/fetchLogs";
import InputDateForm from "../../../../../../components/InputDateForm";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";
import { Form } from "react-bootstrap";
import debounce from "lodash.debounce";
import { format } from "date-fns";

export const Publications = () => {
  const [page, setPage] = useState(1);

  const [isNotified, setIsNotified] = useState(undefined);
  const [courtCaseNumber, setCourtCaseNumber] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  const {
    data: item,
    isLoading,
    error,
    refetch,
  } = useFetchData({
    queryParams: {
      page,
      limit: 10,
      isNotified: isNotified ?? "null",
      courtCaseNumber: courtCaseNumber.replace(/[.-]/g, "").trim(),
      publicationDate: selectedDate ?? "null",
    },
  });

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const [publication, setPublication] = useState();
  const [openPublicationModal, setOpenPublicationModal] = useState(false);
  const togglePublicationModal = () => {
    setOpenPublicationModal(!openPublicationModal);
  };

  const debouncedFilterChange = useCallback(
    debounce((value) => {
      setPage(1);
      setCourtCaseNumber(value);
    }, 300),
    []
  );

  useEffect(() => () => debouncedFilterChange.cancel(), [debouncedFilterChange]);

  // if (isLoading) return <Loading />;
  const handleChange = (selectedOption) => {
    setPage(1);
    setIsNotified(selectedOption ? selectedOption.value : null);
  };
  const handleDateChange = async (date) => {
    const formattedDate = date ? format(date, "yyyy-MM-dd") : null;

    setPage(1);
    setSelectedDate(formattedDate);
  };
  return (
    <>
      <PublicationModal
        open={openPublicationModal}
        handleClose={togglePublicationModal}
        publication={publication}
      />

      <LabelWithBackLine>PUBLICAÇÕES ENCONTRADAS</LabelWithBackLine>

      <div className="xv-inline-filter-row" aria-live="polite">
        <button className="btn btn-secondary" type="button" onClick={refetch} disabled={isLoading}>
          Atualizar publicações
        </button>
        {error && <p role="alert">{error}</p>}
        {!isLoading && !error && item?.data?.length === 0 &&
          <p role="status">Nenhuma publicação encontrada para os filtros selecionados.</p>}
      </div>
      <Table.Root>
        <div className="xv-inline-filter-row xv-publication-filters">
          <Form.Control
            type="text"
            name="courtCaseNumber"
            style={{
              // paddingLeft: "60px",
              border: `0.5px solid ${globalColors.backgroundColor2}`,
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
              display: "block",
            }}
            onChange={(e) => debouncedFilterChange(e.target.value)}
            placeholder="Busque por número do processo, diário ou vara"
          />
          <InputForm
            name="type"
            placeholder="Notificados"
            label="Notificados"
            isSelect={true}
            options={[
              { value: true, label: "Sim" },
              { value: false, label: "Não" },
            ]}
            onChange={handleChange}
            required={true}
            isClearable
          />
          <InputDateForm
            name="dateField"
            label="Data da Publicação"
            placeholder="Selecione uma data"
            onChange={handleDateChange}
            value={selectedDate}
          />
        </div>
        <Table.Content>
          <Table.Head
            tableHeaders={[
              "Nº Autos processo",
              "E-mail",
              "WhatsApp",
              "Diário",
              "Vara",
              "Texto Original",
              "Data Publicação",
              "",
              "",
            ]}
          />
          <Table.Body
            setPublication={setPublication}
            togglePublicationModal={togglePublicationModal}
            logsList={item?.data ?? []}
          />
        </Table.Content>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "24px",
          }}
        >
          {isLoading && <p>Carregando...</p>}
        </div>
        <Table.Pagination
          count={item?.meta?.pageCount ?? item?.meta?.lastPage ?? 0}
          page={item?.meta?.page ?? item?.meta?.currentPage ?? page}
          hasPreviousPage={item?.meta?.hasPreviousPage ?? false}
          hasNextPage={item?.meta?.hasNextPage ?? false}
          onChange={handlePageChange}
        />
      </Table.Root>
    </>
  );
};

export default Publications;
